import { render, staticRenderFns } from "./homework-attach-file.vue?vue&type=template&id=ca68b9f2"
import script from "./homework-attach-file.vue?vue&type=script&lang=js"
export * from "./homework-attach-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports